import { TypedResource } from "./base";
import { Tenant } from "../domains/tenant";

const ENDPOINT = {
  TENANT_MANAGEMENT: {
    TENANTS_SLUG: (slug: string) =>
      `/api/tenant-management/v1/organizations-slug/${slug}`,
    GBIZID_ACTIVATED_TENANTS: `/api/tenant-management/v1/organizations-gbizid-activated`,
  },
};

class ApiClient {
  // cloud gov
  fetchTenantBySlug = (slug: string) =>
    TypedResource<Tenant, null>(
      ENDPOINT.TENANT_MANAGEMENT.TENANTS_SLUG(slug),
      "GET",
    );
  fetchGBizIDActivatedTenants = () =>
    TypedResource<Tenant[], null>(
      ENDPOINT.TENANT_MANAGEMENT.GBIZID_ACTIVATED_TENANTS,
      "GET",
    );
}

const apiClient = new ApiClient();

export default apiClient;
